import { makeStyles } from '@vakantiesnl/components/src/styles/themes/themewrapper';

export const useStyles = makeStyles()(() => ({
	container: {
		cursor: 'pointer',
	},
	disabled: {
		opacity: '0.5',
		cursor: 'not-allowed',
	},
}));
